import { QueryClient } from '@tanstack/react-query'

export let queryClient: QueryClient | null = null

export const setQueryClient = (_queryClient: QueryClient) => {
  queryClient = _queryClient
}
